export const FINAL_CTA_STAMP = "SHIFT COMPARISON";

export const FINAL_CTA_SCAN_PILLS = [
  { value: "8H", label: "Your business" },
  { value: "24/7", label: "Digital assistant" },
  { value: "14-DAY", label: "Free trial" },
  { value: "72H", label: "Go live" },
];

export const FINAL_CTA_HEADLINE = {
  businessLine: "Your Business Runs",
  businessHours: "8 Hours a Day.",
  aiLine: "Your Digital Assistant Runs",
  aiHours: "24/7.",
};

export const FINAL_CTA_BODY =
  "While you're on a job or asleep, your Digital assistant qualifies leads, handles price questions, collects photos, and fills your calendar for tomorrow — so competitors don't win by simply answering first.";

export const FINAL_CTA_URGENCY =
  "Every unanswered message is a lead your competitor can take tonight.";

export const FINAL_CTA_SHIFTS = [
  {
    id: "business",
    label: "YOUR BUSINESS",
    value: "8H",
    barWidth: "33%",
    window: "Typical office hours · Mon–Fri",
    detail: "On the roof, with crew, after 5 PM — leads wait",
    tone: "muted",
  },
  {
    id: "ai",
    label: "DIGITAL ASSISTANT",
    value: "24/7",
    barWidth: "100%",
    window: "Nights · weekends · storm season",
    detail: "Qualifies, answers pricing, collects photos, books inspections",
    tone: "hero",
    highlight: true,
  },
];

export const FINAL_CTA_GAP = {
  value: "16H+",
  label: "Uncovered hours without AI",
  detail: "Evenings, Sundays, 2 AM leak emergencies — when competitors answer first",
};

export const FINAL_CTA_TIMELINE_LABELS = ["12 AM", "6 AM", "12 PM", "6 PM", "12 AM"];
